import { Component, Inject, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { NearbySchoolsState } from '../nearby-schools/nearby-schools.state';
import { ContentService } from '../services/content.service';
import { RootState } from '../store/root.state';
import { Application, Household } from '../types';
import { IApplicationContent } from '../types/content.type';
import { INearbySchool } from '../types/nearby-school.type';
import { ISchool } from '../types/school.type';
import { DataFilterPipe } from '../pipes/data-filter.pipe';
import { PossessivePipe } from '../pipes/possessive.pipe';
import { FullNamePipe } from '../pipes/full-name.pipe';
import { NgFor, NgIf, DecimalPipe } from '@angular/common';
import { APP_CONFIG, IAppSettings } from '@nha/config/interfaces/iapp-settings.interface';

declare const $: any;
@Component({
	selector: 'app-submitted',
	templateUrl: './submitted.component.html',
	styleUrls: ['./submitted.component.scss'],
	standalone: true,
	imports: [NgFor, NgIf, DecimalPipe, FullNamePipe, PossessivePipe, DataFilterPipe]
})
export class SubmittedComponent implements OnInit, OnDestroy {
	appSettings = inject<IAppSettings>(APP_CONFIG);

	@Input() appData: Application;
	@Input() uniqueHouseholds: Household[];

	appContent: IApplicationContent;
	nearbySchoolsApplying: INearbySchool[] = [];
	showReviewForm = false;
	reviewFormToggled = false;
	termsConditionsUrl: string;
	guardianEmail = '';
	appliedSchools: ISchool[] = [];
	howHeardLink: string;

	private contentSub: Subscription;
	private nearbySchoolsSub: Subscription;
	private schoolsSub: Subscription = null;

	constructor(private contentService: ContentService, private store: Store) {}

	ngOnInit(): void {
		this.contentSub = this.store.select(RootState.content).subscribe((content) => {
			if (content) {
				this.appContent = content;
				this.termsConditionsUrl = `${this.appSettings.api.application}/content/termsconditions?stateCode=${content.stateCode}`;
			}
		});

		this.store.select(NearbySchoolsState.nearbySchoolsApplying).subscribe((nearbySchools) => {
			this.nearbySchoolsApplying = nearbySchools;
		});

		const guardiansWithEmail = this.appData.guardians.filter((g) => g.email !== '');

		if (guardiansWithEmail.length > 0) {
			this.guardianEmail = guardiansWithEmail[0].email;
		}

		this.schoolsSub = this.contentService.getAllSchoolsBySchoolId(this.appContent.schoolID, 'en-us').subscribe((schools: ISchool[]) => {
			if (schools) {
				this.appliedSchools = schools;

				if (this.appContent.schoolID === 497 || this.appContent.schoolID === 508) {
					let westfieldCharter = false;
					let westfieldPrep = false;

					this.appData.children.forEach((child) => {
						if (child.applicationForSchools[0].gradeLevelId <= 7 || child.applicationForSchools[0].gradeLevelId > 14) {
							westfieldCharter = true;
						} else if (child.applicationForSchools[0].gradeLevelId > 7 && child.applicationForSchools[0].gradeLevelId < 14) {
							westfieldPrep = true;
						}
					});

					if (!westfieldCharter) {
						this.appliedSchools = this.appliedSchools.filter((school) => school.schoolName !== 'Westfield Charter Academy');
					}

					if (!westfieldPrep) {
						this.appliedSchools = this.appliedSchools.filter((school) => school.schoolName !== 'Westfield Prep');
					}
				}
			}
		});

		window.scrollTo(0, 0);
	}

	ngOnDestroy(): void {
		this.contentSub.unsubscribe();
		this.nearbySchoolsSub.unsubscribe();
		this.schoolsSub.unsubscribe();
	}

	goToHomepage(): void {
		window.location.href = window.location.href.split('/apply')[0];
	}

	toggleReviewForm(): void {
		this.showReviewForm = !this.showReviewForm;

		if (this.showReviewForm) {
			window.scrollTo(0, document.getElementById('nha-sa-review-app').offsetTop);
		}

		if (!this.reviewFormToggled) {
			setTimeout(() => {
				($('.nha-sa-terms-link-submitted') as any).modaal({
					type: 'ajax',
					width: 800
				});
			}, 500);
			this.reviewFormToggled = true;
		}
	}

	howHeardLinkUrl(): string {
		return (this.howHeardLink = `https://surveys.nhaschools.com/take/${this.appContent.schoolID}ReasonToApply`);
	}
}
